import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";

const state = {
};
const getters = {
};

const actions = {
  [actionType.CREATE_ALERT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post("/user/listing-alerts/",params).then(result => {
          resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.UPDATE_ALERT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.put(`user/listing-alerts/${params.id}`,params.body).then(result => {
          resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.ENABLE_DISABLE_ALERT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.put(`/user/listing-alerts/${params.id}/active`).then(result => {
          resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.DELETE_ALERT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.delete(`/user/listing-alerts/${params.id}`).then(result => {
          resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_ALERTS]: async function ({ commit }, params) {
    console.log("params",params);
    return new Promise((resolve, reject) => {
      api.get(`/user/listing-alerts`,{params}).then(result => {
          resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_SPECIFIC_ALERT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`/user/listing-alerts/${params.id}`).then(result => {
          resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_ALERT_MACTHES]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`/user/listing-alerts/matches`,{params}).then(result => {
          resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
};


const mutations = {
  [mutationType.LIST_CATEGORY](state, data) {
    
  },
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}